
import React from "react";
import { Button } from "@/components/ui/button";
import { Settings } from "lucide-react";

interface ProfileHeaderProps {
  onSettingsClick: () => void;
}

export const ProfileHeader: React.FC<ProfileHeaderProps> = ({ onSettingsClick }) => {
  return (
    <header className="bg-white shadow-sm px-4 py-3 fixed w-full top-0 z-50">
      <div className="flex items-center justify-between">
        <h1 className="text-lg font-bold">Mon Profil</h1>
        <Button variant="ghost" size="sm" onClick={onSettingsClick}>
          <Settings className="h-4 w-4" />
        </Button>
      </div>
    </header>
  );
};
